import { Scene } from "@babylonjs/core/scene";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { STEP_FRAMES, HOP_HEIGHT } from "./constants";

// ジャンプアニメ：X/Z 線形補間 + 弧（|deltaY|+HOP_HEIGHT）、終端 Y は target.y
// deltaY は target.y - start.y で算出、ボタン乗降の nextStepOffset も target.y に含めた状態で渡す
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performCharJump = (
  scene: Scene,
  node: AbstractMesh,
  target: { x: number; y: number; z: number },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();
    scene.getAnimationGroupByName("ArmLeftAction")?.start();
    scene.getAnimationGroupByName("ArmRightAction")?.start();

    const start = node.position.clone();
    const deltaY = target.y - start.y;
    const arc = Math.abs(deltaY) + HOP_HEIGHT;
    const anim = new Animation(
      "charJump",
      "position",
      STEP_FRAMES,
      Animation.ANIMATIONTYPE_VECTOR3,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    const keys = [];
    for (let i = 0; i <= STEP_FRAMES; i++) {
      const t = i / STEP_FRAMES;
      const yLerp = start.y + deltaY * t;
      keys.push({
        frame: i,
        value: new Vector3(
          start.x + (target.x - start.x) * t,
          yLerp + arc * Math.sin(t * Math.PI),
          start.z + (target.z - start.z) * t,
        ),
      });
    }
    keys[keys.length - 1].value = new Vector3(target.x, target.y, target.z);
    anim.setKeys(keys);

    const a = scene.beginDirectAnimation(node, [anim], 0, STEP_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => {
      scene.getAnimationGroupByName("ArmLeftAction")?.stop();
      scene.getAnimationGroupByName("ArmRightAction")?.stop();
      resolve();
    };
  });
